import React, { useEffect } from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { ErrorView } from "components/ErrorView/ErrorView";
import { routes } from "routes";

import * as Sentry from "@sentry/react";
import { getWebsocketService } from "services/websocket.service";
const router = createBrowserRouter(routes);

export default function App() {
  useEffect(() => {
    getWebsocketService().init();
  }, []);
  return (
    <Sentry.ErrorBoundary fallback={(err) => <ErrorView eventId={err.eventId} error={err.error} />}>
      <div className="App">
        <RouterProvider router={router} />
      </div>
    </Sentry.ErrorBoundary>
  );
}
